import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class SearchService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    get(query) {
        if (typeof (query) === 'undefined' || query === null)
            query = 'empty'

        return Vue.axios.get(`${APIHOST}/api/search`, {
            params: {
                id: `${query}`
            },
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new SearchService()